import {
  ITennisLiveScore
} from "@sky-it-livedata/livedata-sports-design-system";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { LiveScoreData } from "../types";
import { intcmpMap } from "../../../utils/intcmp";
import { CreateSdapiLiveScoreWidgetInputSchema } from "appsync";

const isValidObject = (obj: LiveScoreData) =>
  Boolean(obj?.data?.getSdapiLiveScoreWidget);

export const transformQuery = (obj: LiveScoreData): ITennisLiveScore => {
  console.log(obj);
  if (isValidObject(obj)) {
      CreateSdapiLiveScoreWidgetInputSchema().parse(obj.data.getSdapiLiveScoreWidget, {reportInput: true});
      const { liveTournaments, ctaUrls } = obj?.data?.getSdapiLiveScoreWidget;

      return {
        liveTournaments,
        ctaUrls: {
          atpCalendarUrl: { url: ctaUrls?.atpCalendarUrl || "", intcmp: intcmpMap.liveScoreAtpCalendar},
          atpRankingUrl: { url: ctaUrls?.atpRankingUrl || "", intcmp: intcmpMap.liveScoreAtpRanking},
          wtaCalendarUrl: { url: ctaUrls?.wtaCalendarUrl || "", intcmp: intcmpMap.liveScoreWtaCalendar},
          wtaRankingUrl: { url: ctaUrls?.wtaRankingUrl || "", intcmp: intcmpMap.liveScoreWtaRanking},
        },
        resultsIntcmp: intcmpMap.liveScoreAtpResults,
      } as ITennisLiveScore;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LiveScoreQuery object',
      data: obj
    });
  }
};